<template>
  <div class="w-full px-2 py-3 bg-theme-39 border-theme-40 border-2 rounded-md">
    <h3 class="text-lg font-semibold mb-2">
      การค้นหาภายใต้เงื่อนไข
    </h3>
    <hr class="border-white border mb-3">
    <FilterSummaryItem
      v-for="item in items"
      :key="item.titel"
      :title="item.title"
      :text="item.text"
    />
  </div>
</template>

<script setup>
import FilterSummaryItem from "../filter-summary-item/index.vue";
const props = defineProps({
  items: Array,
});
</script>
